//product insights Top Revenue
export const PRODUCT_INSIGHTS_TOP_REVENUE_REQUEST = 'PRODUCT_INSIGHTS_TOP_REVENUE_REQUEST';
export const PRODUCT_INSIGHTS_TOP_REVENUE_SUCCESS = 'PRODUCT_INSIGHTS_TOP_REVENUE_SUCCESS';
export const PRODUCT_INSIGHTS_TOP_REVENUE_FAILURE = 'PRODUCT_INSIGHTS_TOP_REVENUE_FAILURE';

// Produuct insights top popular
export const PRODUCT_INSIGHTS_TOP_POPULAR_REQUEST = 'PRODUCT_INSIGHTS_TOP_POPULAR_REQUEST';
export const PRODUCT_INSIGHTS_TOP_POPULAR_SUCCESS = 'PRODUCT_INSIGHTS_TOP_POPULAR_SUCCESS';
export const PRODUCT_INSIGHTS_TOP_POPULAR_FAILURE = 'PRODUCT_INSIGHTS_TOP_POPULAR_FAILURE';

export const PRODUCT_INSIGHTS_TOP_LEAST_POPULAR_REQUEST = 'PRODUCT_INSIGHTS_TOP_LEAST_POPULAR_REQUEST';
export const PRODUCT_INSIGHTS_TOP_LEAST_POPULAR_SUCCESS = 'PRODUCT_INSIGHTS_TOP_LEAST_POPULAR_SUCCESS';
export const PRODUCT_INSIGHTS_TOP_LEAST_POPULAR_FAILURE = 'PRODUCT_INSIGHTS_TOP_LEAST_POPULAR_FAILURE';

// Produuct insights top popular revenue
export const PRODUCT_INSIGHTS_TOP_POPULAR_REVENUE_REQUEST = 'PRODUCT_INSIGHTS_TOP_POPULAR_REVENUE_REQUEST';
export const PRODUCT_INSIGHTS_TOP_POPULAR_REVENUE_SUCCESS = 'PRODUCT_INSIGHTS_TOP_POPULAR_REVENUE_SUCCESS';
export const PRODUCT_INSIGHTS_TOP_POPULAR_REVENUE_FAILURE = 'PRODUCT_INSIGHTS_TOP_POPULAR_REVENUE_FAILURE';

export const PRODUCT_INSIGHTS_TOP_LEAST_POPULAR_REVENUE_REQUEST = 'PRODUCT_INSIGHTS_TOP_LEAST_POPULAR_REVENUE_REQUEST';
export const PRODUCT_INSIGHTS_TOP_LEAST_POPULAR_REVENUE_SUCCESS = 'PRODUCT_INSIGHTS_TOP_LEAST_POPULAR_REVENUE_SUCCESS';
export const PRODUCT_INSIGHTS_TOP_LEAST_POPULAR_REVENUE_FAILURE = 'PRODUCT_INSIGHTS_TOP_LEAST_POPULAR_REVENUE_FAILURE';

// Produuct insights top revenue streams
export const PRODUCT_INSIGHTS_TOP_REVENUE_STREAMS_REQUEST = 'PRODUCT_INSIGHTS_TOP_REVENUE_STREAMS_REQUEST';
export const PRODUCT_INSIGHTS_TOP_REVENUE_STREAMS_SUCCESS = 'PRODUCT_INSIGHTS_TOP_REVENUE_STREAMS_SUCCESS';
export const PRODUCT_INSIGHTS_TOP_REVENUE_STREAMS_FAILURE = 'PRODUCT_INSIGHTS_TOP_REVENUE_STREAMS_FAILURE';

// Produuct insights cancelled items
export const PRODUCT_INSIGHTS_CANCELLED_ITEMS_REQUEST = 'PRODUCT_INSIGHTS_CANCELLED_ITEMS_REQUEST';
export const PRODUCT_INSIGHTS_CANCELLED_ITEMS_SUCCESS = 'PRODUCT_INSIGHTS_CANCELLED_ITEMS_SUCCESS';
export const PRODUCT_INSIGHTS_CANCELLED_ITEMS_FAILURE = 'PRODUCT_INSIGHTS_CANCELLED_ITEMS_FAILURE';

//Produuct insights cancelled reasons
export const PRODUCT_INSIGHTS_CANCELLED_REASONS_REQUEST = 'PRODUCT_INSIGHTS_CANCELLED_REASONS_REQUEST';
export const PRODUCT_INSIGHTS_CANCELLED_REASONS_SUCCESS = 'PRODUCT_INSIGHTS_CANCELLED_REASONS_SUCCESS';
export const PRODUCT_INSIGHTS_CANCELLED_REASONS_FAILURE = 'PRODUCT_INSIGHTS_CANCELLED_REASONS_FAILURE';

//Produuct insights items cancelled reasons
export const PRODUCT_INSIGHTS_ITEMS_CANCELLED_REASONS_REQUEST = 'PRODUCT_INSIGHTS_ITEMS_CANCELLED_REASONS_REQUEST';
export const PRODUCT_INSIGHTS_ITEMS_CANCELLED_REASONS_SUCCESS = 'PRODUCT_INSIGHTS_ITEMS_CANCELLED_REASONS_SUCCESS';
export const PRODUCT_INSIGHTS_ITEMS_CANCELLED_REASONS_FAILURE = 'PRODUCT_INSIGHTS_ITEMS_CANCELLED_REASONS_FAILURE';

//Product insights availibilty items by channels
export const PRODUCT_INSIGHTS_AVAILABILITY_BY_CHANNELS_REQUEST = 'PRODUCT_INSIGHTS_AVAILABILITY_BY_CHANNELS_REQUEST';
export const PRODUCT_INSIGHTS_AVAILABILITY_BY_CHANNELS_SUCCESS = 'PRODUCT_INSIGHTS_AVAILABILITY_BY_CHANNELS_SUCCESS';
export const PRODUCT_INSIGHTS_AVAILABILITY_BY_CHANNELS_FAILURE = 'PRODUCT_INSIGHTS_AVAILABILITY_BY_CHANNELS_FAILURE';

//Product insights availibilty items by channels Details
export const PRODUCT_INSIGHTS_AVAILABILITY_BY_CHANNELS_DETAILS_REQUEST = 'PRODUCT_INSIGHTS_AVAILABILITY_BY_CHANNELS_DETAILS_REQUEST';
export const PRODUCT_INSIGHTS_AVAILABILITY_BY_CHANNELS_DETAILS_SUCCESS = 'PRODUCT_INSIGHTS_AVAILABILITY_BY_CHANNELS_DETAILS_SUCCESS';
export const PRODUCT_INSIGHTS_AVAILABILITY_BY_CHANNELS_DETAILS_FAILURE = 'PRODUCT_INSIGHTS_AVAILABILITY_ITEMS_BY_CHANNELS_DETAILS_FAILURE';

//Product availability dropdown
export const PRODUCT_AVAILABILITY_DROPDOWN_REQUEST = 'PRODUCT_AVAILABILITY_DROPDOWN_REQUEST';
export const PRODUCT_AVAILABILITY_DROPDOWN_SUCCESS = 'PRODUCT_AVAILABILITY_DROPDOWN_SUCCESS';
export const PRODUCT_AVAILABILITY_DROPDOWN_FAILURE = 'PRODUCT_AVAILABILITY_DROPDOWN_FAILURE';

//Category & Item Sales :
export const CATEGORY_ITEM_SALES_REQUEST = "CATEGORY_ITEM_SALES_REQUEST"
export const CATEGORY_ITEM_SALES_FAILURE = "CATEGORY_ITEM_SALES_FAILURE"
export const CATEGORY_ITEM_SALES_SUCCESS = "CATEGORY_ITEM_SALES_SUCCESS"

//Category & Item Sales Dropdown :
export const CATEGORY_ITEM_SALES_DROPDOWN_REQUEST = "CATEGORY_ITEM_SALES_DROPDOWN_REQUEST";
export const CATEGORY_ITEM_SALES_DROPDOWN_SUCCESS = "CATEGORY_ITEM_SALES_DROPDOWN_SUCCESS";
export const CATEGORY_ITEM_SALES_DROPDOWN_FAILURE = "CATEGORY_ITEM_SALES_DROPDOWN_FAILURE";
